import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class SlackMeetingStoreMappingService extends BaseService {
  search = (data) => {
    return this.axios.post(API_ENDPOINTS.SLACK_MEETING_STORE_MAPPINGS_SEARCH, data);
  };

  getDetail = ({ slackMeetingStoreMappingId }) => {
    return this.axios.get(
      API_ENDPOINTS.SLACK_MEETING_STORE_MAPPING_DETAIL.replace(
        "{slackMeetingStoreMappingId}",
        slackMeetingStoreMappingId
      )
    );
  };

  create = (data) => {
    return this.axios.post(API_ENDPOINTS.SLACK_MEETING_STORE_MAPPING_CREATE, data);
  };

  update = (data) => {
    return this.axios.put(
      API_ENDPOINTS.SLACK_MEETING_STORE_MAPPING_UPDATE.replace(
        "{slackMeetingStoreMappingId}",
        data.slackMeetingStoreMappingId
      ),
      data
    );
  };

  delete = ({ slackMeetingStoreMappingId }) => {
    return this.axios.delete(
      API_ENDPOINTS.SLACK_MEETING_STORE_MAPPING_DELETE.replace(
        "{slackMeetingStoreMappingId}",
        slackMeetingStoreMappingId
      )
    );
  };
}
